export const mainURL="https://zwajy.net/laravel/api";